import { render, staticRenderFns } from "./Delegation-list.vue?vue&type=template&id=5d56756f&"
import script from "./Delegation-list.vue?vue&type=script&lang=js&"
export * from "./Delegation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports